import React, { FC } from "react";

interface TextInputProps {
    value?: string;
    placeholder?: string;
    disabled?: boolean;
    handleUpdate?: (value: string) => void;
}

const TextInput: FC<TextInputProps> = ({
    value = "",
    placeholder = "",
    disabled = false,
    handleUpdate = () => {},
}) => {
    return (
        <input
            className={
                `px-2 py-1.5 rounded-md flex-1 w-full outline outline-0 bg-light disabled:bg-gray-100 text-sm text-gray-800 disabled:text-gray-400 
                 border border-gray-600 dark:border-gray-300 forced-colors:border-[Highlight]`
            }
            type="text"
            value={value ?? ""}
            disabled={disabled}
            placeholder={placeholder ? placeholder : ""}
            onChange={(e) => handleUpdate(e.target.value)}
        />
    );
};

export default TextInput;
